import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {userT} from '@/lib/types/user.types';

const sliceName = `user`;

const USER_INITIAL: userT = {
  uid: null,
  username: ``,
  email: ``,
};

const userSlice = createSlice({
  name: sliceName,
  initialState: {
    ...USER_INITIAL,
  },
  reducers: {
    USER_UPDATE: (
      state,
      action: PayloadAction<{
        data?: userT;
        prop?: string;
        value?: any;
      }>
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? {[action.payload.prop]: action.payload.value} : null),
      });
    },
  },
});

const {USER_UPDATE} = userSlice.actions;

export {userSlice, USER_INITIAL, USER_UPDATE};
